<template>
  <div class="d-flex flex-column login-page__form">
    <div class="d-flex align-center login-page__form__tab mb-6">
      <button
        :class="['login-page__form__tab__btn mr-4', { active: tab === item }]"
        v-for="(item, i) in TABS"
        :key="`tabs-${i}`"
        @click="tab = item"
      >
        {{ $t(item) }}
      </button>
    </div>
    <v-card width="100%" class="login-page__form__block">
      <v-card-title class="justify-center pb-0 login-page__form__block__title">
        {{ $t(tab) }}
      </v-card-title>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <v-form @submit.prevent="handleSubmit(submit)">
          <v-card-text class="login-page__form__block__card-text">
            <div v-if="tab === TABS.FORM">
              <validation-provider
                v-slot="{ errors }"
                :name="$t('login')"
                rules="required"
                vid="userName"
              >
                <v-text-field
                  ref="name"
                  v-model="user.userName"
                  :error-messages="errors[0]"
                  autofocus
                  class="text-field_v1"
                  :placeholder="$t('login')"
                  required
                />
              </validation-provider>
              <validation-provider
                v-slot="{ errors }"
                :name="$t('password')"
                rules="required"
                vid="password"
              >
                <v-text-field
                  ref="state"
                  v-model="user.password"
                  :error-messages="errors[0]"
                  class="text-field_v1"
                  :placeholder="$t('password')"
                  type="password"
                />
              </validation-provider>
            </div>
            <div v-if="tab === TABS.EDS">
              <div class="login-page__form__block__card-text__eds">
                <div
                  class="login-page__form__block__card-text__eds__main"
                  @click="isOpen = !isOpen"
                >
                  <div
                    v-if="!selectedKey"
                    class="d-flex align-center justify-space-between"
                    style="height: 100%"
                  >
                    <div></div>
                    <div
                      class="login-page__form__block__card-text__eds__main__text"
                    >
                      {{ $t("selectKey") }}
                    </div>
                    <div>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.17 6L11.17 8H20V18H4V6H9.17ZM10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z"
                          fill="#7A889B"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    v-else
                    class="d-flex align-center justify-space-between"
                    style="height: 100%"
                  >
                    <div class="d-flex align-center flex-wrap">
                      <p
                        v-if="selectedKey?.tin"
                        class="mb-0 login-page__form__block__card-text__eds__content__inner__tin font-weight-bold"
                      >
                        <span
                          class="login-page__form__block__card-text__eds__content__inner__tin--key mr-1"
                          >{{ $t("eimzo.stir") }}:</span
                        >{{ selectedKey.tin }}
                      </p>
                    </div>
                    <div>
                      <h4
                        v-if="selectedKey?.name"
                        class="mb-0 login-page__form__block__card-text__eds__content__inner__name"
                      >
                        {{ selectedKey.name }}
                      </h4>
                    </div>
                    <div>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.17 6L11.17 8H20V18H4V6H9.17ZM10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z"
                          fill="#7A889B"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <transition name="fade" mode="out-in">
                  <div
                    v-if="isOpen"
                    class="login-page__form__block__card-text__eds__content"
                  >
                    <div v-for="(item, i) in keys" :key="`key-${i}`">
                      <div
                        class="login-page__form__block__card-text__eds__content__inner"
                        @click="selectKey(item)"
                      >
                        <div
                          class="d-flex align-center justify-space-between mb-4"
                        >
                          <h4
                            v-if="item?.name"
                            class="mb-0 login-page__form__block__card-text__eds__content__inner__name"
                          >
                            {{ item.name }}
                          </h4>
                          <p
                            v-if="item?.face"
                            class="mb-0 login-page__form__block__card-text__eds__content__inner__face"
                          >
                            {{ item.face }}
                          </p>
                        </div>
                        <div
                          class="d-flex align-center mb-4"
                          v-if="item?.organisation"
                        >
                          <span
                            class="login-page__form__block__card-text__eds__content__inner__organisation--key"
                            >{{ $t("eimzo.organization") }}:</span
                          >
                          <p
                            class="mb-0 login-page__form__block__card-text__eds__content__inner__organisation"
                          >
                            {{ item.organisation }}
                          </p>
                        </div>
                        <div class="d-flex align-center flex-wrap mb-4">
                          <p
                            v-if="item.tin"
                            class="mb-0 login-page__form__block__card-text__eds__content__inner__tin"
                          >
                            <span
                              class="login-page__form__block__card-text__eds__content__inner__tin--key mr-1"
                              >{{ $t("eimzo.stir") }}:</span
                            >{{ item.tin }}
                          </p>
                          <p
                            v-if="item.pnfl"
                            class="mb-0 login-page__form__block__card-text__eds__content__inner__tin mr-1"
                          >
                            <span
                              class="login-page__form__block__card-text__eds__content__inner__tin--key"
                              >{{ $t("eimzo.pnfl") }}:</span
                            >{{ item.pnfl }}
                          </p>
                        </div>
                        <div class="d-flex align-center justify-space-between">
                          <p
                            v-if="item.certificate"
                            class="mb-0 login-page__form__block__card-text__eds__content__inner__certificate-number"
                          >
                            <span
                              class="login-page__form__block__card-text__eds__content__inner__certificate-number--key mr-2"
                            >
                              <svg
                                class="mr-2"
                                width="14"
                                height="15"
                                viewBox="0 0 14 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M14 0.304634V10.3692C13.8908 10.6063 13.7023 10.675 13.4488 10.6739C12.3501 10.6682 11.2513 10.6689 10.1526 10.6697L10.1485 10.6697C9.77217 10.67 9.39587 10.6702 9.01957 10.6702H8.85154C9.15508 10.1735 9.26722 9.6555 9.16385 9.0992C9.06048 8.54326 8.78543 8.08777 8.33907 7.74149C7.5837 7.15633 6.51858 7.14063 5.73982 7.70241C5.35081 7.98294 5.08125 8.35588 4.93514 8.81173C4.72767 9.45935 4.81497 10.0767 5.17439 10.6702H5.00454H0.520507C0.144281 10.6702 0 10.5263 0 10.1515V0.525256C0 0.147203 0.142455 0.00365268 0.51722 0.00365268L2.86843 0.00374928C6.39532 0.00396663 9.92237 0.00418399 13.4492 0C13.703 0 13.8912 0.0672094 14 0.304634ZM6.98941 4.95413H10.9924L11.0281 4.95443C11.0618 4.95485 11.0955 4.95528 11.129 4.95231C11.3398 4.93477 11.5038 4.76456 11.5111 4.55782C11.5184 4.35728 11.3726 4.17575 11.171 4.13995C11.1311 4.1328 11.0899 4.13318 11.0489 4.13357L11.0212 4.13374H2.97365L2.94786 4.13358C2.91994 4.13332 2.89208 4.13305 2.86443 4.13557C2.67194 4.15346 2.51524 4.30542 2.49113 4.49536C2.46702 4.6842 2.58318 4.87049 2.77129 4.9282C2.83923 4.94902 2.91448 4.95304 2.98607 4.95304C4.09801 4.95425 5.21021 4.9542 6.32224 4.95415L6.98941 4.95413ZM6.9905 6.59492H10.5292C10.5858 6.59492 10.6424 6.59531 10.6989 6.59571H10.699C10.8383 6.59669 10.9776 6.59766 11.1166 6.59273C11.3295 6.58506 11.4961 6.4174 11.5103 6.21066C11.5238 6.01049 11.3843 5.8253 11.1823 5.78366C11.1348 5.77391 11.0848 5.77432 11.0352 5.77473L11.0055 5.77489C9.22882 5.77465 7.45227 5.77473 5.67567 5.77481H5.66781L2.99885 5.77489L2.9631 5.77459H2.9631C2.92938 5.77417 2.89571 5.77375 2.86224 5.77672C2.67011 5.79461 2.51341 5.94766 2.4904 6.1376C2.46739 6.32681 2.58354 6.512 2.77202 6.56935C2.83996 6.59017 2.91521 6.59382 2.9868 6.59419C4.09874 6.5954 5.21094 6.59535 6.32297 6.5953L6.99014 6.59528L6.9905 6.59492ZM6.98466 2.49259L7.52166 2.49275C7.87974 2.49291 8.23788 2.49308 8.59586 2.49259C8.86287 2.49222 9.04696 2.32603 9.04988 2.08714C9.05281 1.84314 8.86579 1.67293 8.59147 1.67256C7.5311 1.67183 6.47073 1.6722 5.41035 1.67256C5.13531 1.67256 4.94792 1.84132 4.94938 2.08459C4.95085 2.32712 5.13786 2.49222 5.41437 2.49296C5.76332 2.49344 6.11228 2.49328 6.46123 2.49312L6.98466 2.49296V2.49259ZM5.68759 14.0066C5.45272 13.9054 5.37456 13.7279 5.37821 13.4744C5.38634 12.9116 5.38486 12.3486 5.38339 11.7857C5.38281 11.5649 5.38223 11.3442 5.38223 11.1235V10.9431C5.84721 11.4219 6.38598 11.6711 7.02849 11.6659C7.67246 11.6608 8.2094 11.4062 8.66526 10.9182C8.66636 10.9417 8.66754 10.9627 8.66863 10.9819L8.66864 10.982C8.67079 11.02 8.67256 11.0513 8.67256 11.0826C8.67267 11.3152 8.67212 11.5477 8.67158 11.7803V11.7803C8.67025 12.3451 8.66893 12.9098 8.67695 13.4744C8.6806 13.7279 8.60134 13.905 8.36756 14.0066H8.17616C8.14713 13.9896 8.11789 13.973 8.08866 13.9564C8.02336 13.9194 7.9581 13.8823 7.89527 13.8415C7.63995 13.6753 7.38463 13.5091 7.13478 13.3348C7.05479 13.2793 7.0011 13.2826 6.9211 13.3356C6.66413 13.5056 6.40432 13.6714 6.14454 13.8371C6.0561 13.8936 5.96767 13.95 5.87936 14.0066H5.68796H5.68759ZM7.01717 10.8466C7.77254 10.843 8.37925 10.2348 8.37925 9.48054H8.37889C8.37925 8.72626 7.77291 8.11845 7.01717 8.11553C6.26325 8.11261 5.65435 8.71676 5.64851 9.4736C5.64266 10.2301 6.2607 10.8503 7.01717 10.8466Z"
                                  fill="#3BB3BD"
                                />
                              </svg>
                              {{ $t("eimzo.certificateNumber") }}:
                            </span>
                            {{ item.certificate }}
                          </p>
                          <p
                            v-if="item.date"
                            class="mb-0 login-page__form__block__card-text__eds__content__inner__valid"
                          >
                            <span
                              class="login-page__form__block__card-text__eds__content__inner__valid--key mr-2"
                            >
                              <svg
                                class="mr-2"
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7 0.333374C3.32 0.333374 0.333332 3.32004 0.333332 7.00004C0.333332 10.68 3.32 13.6667 7 13.6667C10.68 13.6667 13.6667 10.68 13.6667 7.00004C13.6667 3.32004 10.68 0.333374 7 0.333374ZM5.19333 9.86004L2.8 7.46671C2.54 7.20671 2.54 6.78671 2.8 6.52671C3.06 6.26671 3.48 6.26671 3.74 6.52671L5.66667 8.44671L10.2533 3.86004C10.5133 3.60004 10.9333 3.60004 11.1933 3.86004C11.4533 4.12004 11.4533 4.54004 11.1933 4.80004L6.13333 9.86004C5.88 10.12 5.45333 10.12 5.19333 9.86004Z"
                                  fill="#3BB3BD"
                                />
                              </svg>

                              {{ $t("eimzo.valid") }}:
                            </span>
                            {{ item.date }}
                          </p>
                        </div>
                      </div>
                      <v-divider v-if="i < keys.length - 1" />
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <router-link
              to="#"
              class="mb-0 mt-1 d-flex align-center"
              style="color: #48545d; text-decoration: none"
            >
              {{ $t("whatEDSKey") }}
              <span class="ml-2 mt-1">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.33334 3.66666H7.66667V5H6.33334V3.66666ZM6.33334 6.33333H7.66667V10.3333H6.33334V6.33333ZM7 0.333328C3.32 0.333328 0.333336 3.31999 0.333336 7C0.333336 10.68 3.32 13.6667 7 13.6667C10.68 13.6667 13.6667 10.68 13.6667 7C13.6667 3.31999 10.68 0.333328 7 0.333328ZM7 12.3333C4.06 12.3333 1.66667 9.93999 1.66667 7C1.66667 4.06 4.06 1.66666 7 1.66666C9.94 1.66666 12.3333 4.06 12.3333 7C12.3333 9.93999 9.94 12.3333 7 12.3333Z"
                    fill="#0096B2"
                  />
                </svg>
              </span>
            </router-link>
            <div class="card-actions mt-5">
              <div class="text-center flex-grow-1">
                <v-btn
                  :loading="loading"
                  class="my_blue_btn w_100 text-center mb-4 login-page__form__block__submit-btn"
                  type="submit"
                  color="#0096B2"
                  style="font-size: 16px"
                  dark
                  >{{ $t("sign") }}
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-form>
      </validation-observer>
    </v-card>
  </div>
</template>

<script>
import TokenService from "../../services/TokenService";
import { numberOnly } from "@/utils/inputRegExps";

const TABS = {
  FORM: "loginTab",
  EDS: "loginWithEDS",
};

export default {
  name: "login",
  data: () => ({
    numberOnly,
    loading: false,
    tab: TABS["FORM"],
    timeout: 0,
    timeoutForgerRequest: null,
    isOpen: false,
    TABS,
    selectedKey: null,
    user: {
      userName: "",
      password: "",
    },
    keys: [
      {
        name: "Hikmatilla Rajabov Tuxtaevich",
        face: "Юр.лицо",
        organisation: "“FERRET SOFT MCHJ”",
        tin: "206866551",
        pnfl: "20686655108765",
        certificate: "7789вс89",
        date: "11 ноя, 2023",
      },
      {
        name: "ABDULLAEV FARHOD G’ULOM O’G’LI",
        face: "Юр.лицо",
        organisation: "",
        tin: "206866552",
        pnfl: "20686655108765",
        certificate: "7789вс89",
        date: "11 ноя, 2023",
      },
    ],
  }),
  watch: {
    tab() {
      this.isOpen = false;
    },
  },
  methods: {
    selectKey(key) {
      this.selectedKey = key;
      this.isOpen = false;
    },
    setTimeoutForRequest() {
      this.timeout = 60;
      this.timeoutForgerRequest = setInterval(() => {
        this.timeout--;
        if (this.timeout <= 0) {
          clearInterval(this.timeoutForgerRequest);
          this.timeoutForgerRequest = null;
        }
      }, 1000);
    },
    async submit() {
      try {
        this.loading = true;
        const data = {
          userName: this.user.userName.trim(),
          password: this.user.password.trim(),
        };
        const { sessionToken, expiresIn, refreshToken } =
          await this.$store.dispatch("login", data);
        // TODO:
        TokenService.setToken(sessionToken, expiresIn, refreshToken);
        await this.$store.dispatch("getUser");
        try {
          await this.$router.push({ name: "index" });
        } catch (e) {
          console.log("Redirecting from index.........");
        }
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/login.scss";
</style>
